<template>
  <div class="modal_utility">

    <scale-loader v-if="loading"/>

    <template v-else>
      <div class="response_table" v-if="type === 'html'">
        <div class="wrap" v-html="data" />
      </div>

      <div class="response_table" v-if="type !== 'html' && data.length > 0">
        <table v-if="type === 'json'" style="font-size: 12px">
          <tbody class="text_table_field">
            <tr v-for="(item, data_key) in data" :key="data_key">
              <td v-for="(elem, item_key) in item" :key="item_key">
                <span v-html="elem" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="cancel"
        >
          cancel
        </button>
      </div>
    </template>
  </div>

</template>
<script>

export default {
  props: [
    'type',
    'method',
    'url',
    'params'
  ],

  data () {
    return {
      data: '',
      loading: true
    }
  },
  created(){
    this.request(this.method, this.url, this.params).then(response => {
      this.data = this.type === 'json' ? JSON.parse(response.data) : response.data
      this.loading = false
    });
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    request (method, url, params) {
      return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest()
        xhr.open(method, url)

        let headers = {
          'Accept': 'application/json',
          'Content-type': 'application/json',
        }

        if (window.localStorage.getItem('auth') !== undefined) {
          headers['Auth'] = window.localStorage.getItem('auth')
        }

        for (let i in headers) {
          xhr.setRequestHeader(i, headers[i])
        }

        xhr.onload = function () {
          if (xhr.status === 200) {
            resolve({data: xhr.response})
          } else {
            xhr.data = xhr.response
            reject(xhr)
          }
        }
        xhr.send(params)
      })
    },
  }
}

</script>

<style lang='scss' scoped>
  .modal_utility{
    height: 100%;
    .v-spinner {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .response_table{
      height: 90%;
      .wrap{
        height: 100%;
        overflow: auto;
        border: 1px solid #ddd;
        &::-webkit-scrollbar {
          width: 10px;
        }
      }
      table{
        height: 96%;
      }
    }
  }


</style>
